<ng-container *transloco="let t; read: 'ordenes-pago'">
  <div mat-dialog-content>{{ t("confirmacion") }}</div>
  <div fxLayout="row" fxLayoutAlign="center" style="margin-top: 24px;">
    <button mat-raised-button (click)="cancel()" style="margin-right: 8%;">{{ t("cancelar") }}</button>
    <button mat-raised-button (click)="accept()" color="primary">{{ t("aceptar") }}</button>
  </div>
</ng-container>